<h3>Administration Center</h3>
<mat-tab-group class="tab-group">
  <mat-tab class="member-settings-tab" label="MEMBER SETTINGS">
    <app-member-settings></app-member-settings>
  </mat-tab>
  <mat-tab label="ASSUMPTION SETTINGS">
    <app-assumption-settings></app-assumption-settings>
  </mat-tab>
  <mat-tab label="DATA UPLOADER">
    <app-data-uploader></app-data-uploader>
  </mat-tab>
</mat-tab-group>
